"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataEngine = void 0;
const viewer_shared_global_access_objects_1 = require("@shapediver/viewer.shared.global-access-objects");
const DataEngine_1 = require("./DataEngine");
Object.defineProperty(exports, "DataEngine", { enumerable: true, get: function () { return DataEngine_1.DataEngine; } });
const instance = DataEngine_1.DataEngine.instance;
viewer_shared_global_access_objects_1.GlobalAccessObjects.instance.loadContent = instance.loadContent.bind(instance);
//# sourceMappingURL=index.js.map